export class ApiResponse<T> {

  constructor(
      public isError: boolean,
      public message: string,
      public data: T | undefined = undefined
  ) { }
}
  